/* THE KANGMI · journey behaviour. Branching, memory, and the numeral capture.

   WHY THIS IS A FILE AND NOT AN INLINE SCRIPT. It lived inside kangmi-journey.liquid until the
   section outgrew the API's payload ceiling. Moving it out is the right call regardless: the
   browser caches it once instead of re-parsing it inside every HTML response, and `defer` keeps
   it off the parser's critical path.

   IT READS ITS DATA FROM THE DOM, NOT FROM LIQUID. The section prints a JSON blob into a
   script[type=application/json] tag and this file parses it. That is what makes it portable:
   no Liquid interpolation anywhere in here, so it is a static cacheable asset.

   THE CAPTURE IS THE COMMERCIAL POINT. The result is the highest-intent moment on the site —
   the visitor has just been told which of eight products is theirs, by name. Before this, the
   only action was Add to cart, so everyone not buying today left no trace, and the site's only
   other capture is a footer form nobody scrolls to.

   The form posts to Shopify's native customer form and carries contact[tags] with the numeral,
   the name and a `journey` marker. That is what makes the list worth having: on launch day it
   segments into "everyone who resolved to WAKE" rather than being a flat pile of addresses.
   Shopify Email sends to a tag, so this needs no ESP, no app and no third-party script.

   IT SITS BESIDE THE BUY BUTTON, NEVER IN FRONT OF IT. Add to cart stays primary and keeps its
   position. This is for the visitor who was never going to buy on this visit, which is nearly
   all of them. DO NOT turn it into a gate.

   THE RETURN TRIP IS HANDLED. Shopify's customer form posts and redirects back with
   ?customer_posted=true, which would otherwise dump the visitor on a reset journey with no idea
   whether it worked. On that flag the saved result is replayed automatically and the form is
   replaced by a confirmation, so the loop closes.

   MEMORY: three answer keys, three chip labels, a timestamp. Nothing identifying, 30 day
   expiry. Every localStorage call is wrapped — Safari private mode throws on setItem and an
   uncaught exception here would take the whole journey down.

   SELECTION HOLDS 210ms before advancing, matched to .kj__opt.is-picked in kangmi-journey.css.
   Change one and change the other. */

(function () {
  var root = document.querySelector('[data-kj]');
  if (!root) return;

  var data;
  try { data = JSON.parse(root.querySelector('[data-kj-data]').textContent); } catch (e) { return; }

  var steps = root.querySelectorAll('.kj__step');
  var dots = root.querySelectorAll('.kj__dot');
  var count = root.querySelector('[data-kj-count]');
  var resolve = root.querySelector('[data-kj-resolve]');
  var res = root.querySelector('[data-kj-res]');
  var recall = root.querySelector('[data-kj-recall]');
  var recallNum = root.querySelector('[data-kj-recall-num]');

  var ans = {}, trail = [], moved = false;
  var justPosted = /[?&]customer_posted=true/.test(window.location.search);

  var KEY = 'kangmi.journey.v1';
  var MAXAGE = 2592000000;

  function save() {
    try {
      localStorage.setItem(KEY, JSON.stringify({ b: ans.b, f: ans.f, q: ans.q, t: trail, ts: Date.now() }));
    } catch (e) {}
  }
  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.f || !data[o.f]) return null;
      if (!o.ts || (Date.now() - o.ts) > MAXAGE) { localStorage.removeItem(KEY); return null; }
      return o;
    } catch (e) { return null; }
  }
  function forget() { try { localStorage.removeItem(KEY); } catch (e) {} }

  root.classList.add('kj-on');

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function show(el) {
    for (var i = 0; i < steps.length; i++) steps[i].classList.remove('is-on');
    res.classList.remove('is-on');
    if (!el) return;
    el.classList.add('is-on');
    var picked = el.querySelectorAll('.kj__opt.is-picked');
    for (var j = 0; j < picked.length; j++) picked[j].classList.remove('is-picked');
    var h = el.querySelector('.kj__q');
    if (h && moved) h.focus();
  }

  function mark(n) {
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-done', i < n);
    if (count) count.textContent = 'STEP ' + Math.min(n + 1, 3) + ' OF 3';
  }

  function step(n, branch) {
    root.classList.remove('is-landed');
    var sel = branch
      ? '.kj__step[data-step="2"][data-branch="' + branch + '"]'
      : '.kj__step[data-step="' + n + '"]';
    show(root.querySelector(sel));
    mark(n - 1);
  }

  function capture(f, done) {
    var h = '<div class="kj__cap' + (done ? ' is-done' : '') + '">';
    if (done) {
      h += '<p class="kj__cap-k">ON THE LIST</p>';
      h += '<p class="kj__cap-h">' + esc(f.num) + ' · ' + esc(f.name) + '. We will find you.</p>';
      h += '</div>';
      return h;
    }
    var tags = 'journey,numeral-' + f.num + ',' + String(f.name).toLowerCase();
    h += '<p class="kj__cap-k">NOT TODAY</p>';
    h += '<p class="kj__cap-h">First in line when ' + esc(f.name) + ' moves.</p>';
    h += '<form class="kj__cap-form" method="post" action="/contact#kjcap" accept-charset="UTF-8">';
    h += '<input type="hidden" name="form_type" value="customer">';
    h += '<input type="hidden" name="utf8" value="✓">';
    h += '<input type="hidden" name="contact[tags]" value="' + esc(tags) + '">';
    h += '<input class="kj__cap-in" type="email" name="contact[email]" required autocomplete="email" placeholder="Email" aria-label="Email address">';
    h += '<button class="kj__cap-btn" type="submit">Keep me posted</button>';
    h += '</form></div>';
    return h;
  }

  function render(remembered, posted) {
    var f = data[ans.f];
    if (!f) return;
    var offerCache = f.daily === '1' && ans.q !== 'rare';
    var h = '';

    root.style.setProperty('--kj-hue', f.hue);
    root.classList.add('is-landed');

    if (trail.length) {
      h += '<div class="kj__trail">';
      for (var t = 0; t < trail.length; t++) {
        h += '<span class="kj__chip" style="--i:' + t + '">' + esc(trail[t]) + '</span>';
      }
      h += '</div>';
    }

    h += '<div class="kj__res-top">';
    h += '<div class="kj__res-num">' + esc(f.num) + '</div>';
    h += '<div class="kj__res-id">';
    h += '<h3 class="kj__res-name" tabindex="-1">' + esc(f.name) + '</h3>';
    h += '<p class="kj__res-land">' + esc(f.land) + '</p>';
    h += '<p class="kj__res-why">' + f.why + '</p>';
    if (f.warn && f.warn !== '-') h += '<p class="kj__warn">' + esc(f.warn) + '</p>';
    h += '<p class="kj__res-meta"><span class="kj__res-price">' + esc(f.price) + '</span>';
    h += '<span>30 strips · 30 days · one a day</span></p>';
    if (f.vid) {
      h += '<form action="/cart/add" method="post" enctype="multipart/form-data">';
      h += '<input type="hidden" name="id" value="' + esc(f.vid) + '">';
      h += '<input type="hidden" name="quantity" value="1">';
      h += '<button class="kj__buy" type="submit">Add ' + esc(f.name) + '</button></form>';
    } else {
      h += '<a class="kj__buy" href="' + esc(f.url) + '">See ' + esc(f.name) + '</a>';
    }
    h += '</div>';
    if (f.img) h += '<img class="kj__shot" src="' + esc(f.img) + '" alt="" width="132" height="132" loading="lazy">';
    h += '</div>';

    h += capture(f, posted);

    h += '<div class="kj__alt">';
    if (offerCache) {
      h += '<p>More than one winning? <strong>THE CACHE</strong> is the four daily formulas at $32.25 a tin, and it ships free. <a href="/products/the-cache-all-four">See THE CACHE</a></p>';
    }
    if (ans.q === 'daily') {
      h += '<p>Every day means a tin a month. <strong>THE RESUPPLY</strong> takes 15% off and locks it. <a href="/pages/the-resupply">How resupply works</a></p>';
    } else if (!offerCache) {
      h += '<p>Not certain? A tin is thirty days. <a href="/collections/the-range">See all eight</a></p>';
    }
    h += '<button type="button" class="kj__back kj__again" data-kj-again>Start again</button>';
    h += '</div>';

    res.innerHTML = h;
    res.classList.add('is-on');
    mark(3);
    if (!remembered) save();
    var n = res.querySelector('.kj__res-name');
    if (n && moved) n.focus();
  }

  function label(btn) {
    var b = btn.querySelector('b');
    return b ? b.textContent.trim() : '';
  }

  function pick(btn, fn) {
    btn.classList.add('is-picked');
    setTimeout(fn, 210);
  }

  root.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target.closest('button') : null;
    if (!t || !root.contains(t)) return;

    if (t.hasAttribute('data-kj-recall-go')) {
      var s2 = load();
      if (!s2) { recall.hidden = true; return; }
      ans = { b: s2.b, f: s2.f, q: s2.q };
      trail = s2.t || [];
      recall.hidden = true;
      moved = true;
      show(null);
      render(true, false);
      return;
    }
    if (t.hasAttribute('data-kj-recall-x')) { forget(); recall.hidden = true; return; }

    if (t.hasAttribute('data-b')) {
      moved = true; ans.b = t.getAttribute('data-b');
      trail = [label(t)];
      pick(t, function () { step(2, ans.b); });
      return;
    }
    if (t.hasAttribute('data-f')) {
      moved = true; ans.f = t.getAttribute('data-f');
      trail[1] = label(t);
      pick(t, function () { step(3); });
      return;
    }
    if (t.hasAttribute('data-q')) {
      moved = true; ans.q = t.getAttribute('data-q');
      trail[2] = label(t);
      pick(t, function () {
        show(null);
        resolve.classList.add('is-on');
        setTimeout(function () { resolve.classList.remove('is-on'); render(false, false); }, 1100);
      });
      return;
    }
    if (t.hasAttribute('data-kj-back')) {
      moved = true;
      var to = t.getAttribute('data-kj-back');
      if (to === '2' && ans.b) { trail.length = 1; step(2, ans.b); }
      else { trail.length = 0; step(1); }
      return;
    }
    if (t.hasAttribute('data-kj-again')) {
      forget();
      ans = {}; trail = []; res.innerHTML = ''; res.classList.remove('is-on'); step(1);
      return;
    }
  });

  step(1);

  var saved = load();

  if (saved && justPosted) {
    ans = { b: saved.b, f: saved.f, q: saved.q };
    trail = saved.t || [];
    if (recall) recall.hidden = true;
    show(null);
    render(true, true);
  } else if (saved && recall && recallNum) {
    var sf = data[saved.f];
    recallNum.textContent = sf.num + ' · ' + sf.name;
    recall.hidden = false;
  }
})();
